'use client';

import { c as _c } from "react/compiler-runtime";
import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';
import { cn } from '@repo/ui/lib/utils';
function Tooltip(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <TooltipPrimitive.Root data-slot="tooltip" {...props} data-sentry-element="TooltipPrimitive.Root" data-sentry-component="Tooltip" data-sentry-source-file="tooltip.tsx" />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function TooltipContent(t0) {
  const $ = _c(21);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      align: t1,
      alignOffset: t2,
      children,
      className,
      side: t3,
      sideOffset: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  const align = t1 === undefined ? "center" : t1;
  const alignOffset = t2 === undefined ? 0 : t2;
  const side = t3 === undefined ? "top" : t3;
  const sideOffset = t4 === undefined ? 4 : t4;
  let t5;
  if ($[8] !== className) {
    t5 = cn("z-50 inline-flex w-fit max-w-xs origin-(--transform-origin) items-center gap-1.5 rounded-md bg-foreground px-3 py-1.5 text-xs text-background has-data-[slot=kbd]:pr-1.5 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-50 **:data-[slot=kbd]:rounded-sm data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95", className);
    $[8] = className;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TooltipPrimitive.Arrow className="z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground data-[side=bottom]:top-1 data-[side=inline-end]:top-1/2! data-[side=inline-end]:-left-1 data-[side=inline-end]:-translate-y-1/2 data-[side=inline-start]:top-1/2! data-[side=inline-start]:-right-1 data-[side=inline-start]:-translate-y-1/2 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5" data-sentry-element="TooltipPrimitive.Arrow" data-sentry-source-file="tooltip.tsx" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== props || $[13] !== t5) {
    t7 = <TooltipPrimitive.Popup className={t5} data-slot="tooltip-content" {...props} data-sentry-element="TooltipPrimitive.Popup" data-sentry-source-file="tooltip.tsx">{children}{t6}</TooltipPrimitive.Popup>;
    $[11] = children;
    $[12] = props;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== align || $[16] !== alignOffset || $[17] !== side || $[18] !== sideOffset || $[19] !== t7) {
    t8 = <TooltipPrimitive.Portal data-sentry-element="TooltipPrimitive.Portal" data-sentry-component="TooltipContent" data-sentry-source-file="tooltip.tsx"><TooltipPrimitive.Positioner align={align} alignOffset={alignOffset} className="isolate z-70" side={side} sideOffset={sideOffset} data-sentry-element="TooltipPrimitive.Positioner" data-sentry-source-file="tooltip.tsx">{t7}</TooltipPrimitive.Positioner></TooltipPrimitive.Portal>;
    $[15] = align;
    $[16] = alignOffset;
    $[17] = side;
    $[18] = sideOffset;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function TooltipProvider(t0) {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      delay: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const delay = t1 === undefined ? 0 : t1;
  let t2;
  if ($[3] !== delay || $[4] !== props) {
    t2 = <TooltipPrimitive.Provider data-slot="tooltip-provider" delay={delay} {...props} data-sentry-element="TooltipPrimitive.Provider" data-sentry-component="TooltipProvider" data-sentry-source-file="tooltip.tsx" />;
    $[3] = delay;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function TooltipTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} data-sentry-element="TooltipPrimitive.Trigger" data-sentry-component="TooltipTrigger" data-sentry-source-file="tooltip.tsx" />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };